import axios from 'axios';

const { VUE_APP_CTI_URL, VUE_APP_CTI_LOGIN_URL } = process.env;

const api = axios.create({
  baseURL: `${VUE_APP_CTI_URL}/cti`,
  withCredentials: true,
});

// cti always returns a 200 status code. manually check for errors and throw.
api.interceptors.response.use(
  response => {
    const { data } = response;

    if (data && data.errorId) {
      throw new Error(data.message || data.errorId);
    }

    return response;
  },
  error => {
    if (error && error.response && error.response.status === 401 && VUE_APP_CTI_LOGIN_URL) {
      window.open(VUE_APP_CTI_LOGIN_URL, '_self');
    }

    return Promise.reject(error);
  }
);

export default api;
